import React, { useState } from 'react';
import style from './style';

const { SwitchColor } = style;

export default function CustomizedSwitches({ active = true, event = () => {} }) {
  return (
    <div>
      <SwitchColor sx={{ m: 0 }} defaultChecked={active} handlechange={event} />
    </div>
  );
}
